<template>
  <div id="map" class="my-map">
    <div class="div_btn">
      <input id="truck_add_btn" type="button" v-show="show" value="轨迹显示" />
      <input id="truck_clear_btn" type="button" v-show="show" value="轨迹清除" />
      <!-- <input id="btn_haiqu" type="button" value="海区" />
      <input id="btn_paifang" type="button" value="排放" />
      <input id="btn_paifang_china" type="button" value="排放（中国）" />
      <input id="btn_jingji" type="button" value="经济" />
      <input id="btn_port" type="button" value="港口" /> -->
      <input id="btn_guangshan" type="button" value="光栅" v-show="show" />
      <input id="btn_areatime" type="button" value="时区" v-show="show" />
      <input id="btn_latlnggrid" type="button" value="经纬度网格" v-show="show" />
      <!-- <input id='btn_player' type="button" value="播放" > -->
    </div>
  </div>
</template>

<script>
import { isSuccess, getToken } from '@/assets/js/utils'
export default {
  data() {
    return {
      _map: '',
      pid: '',
      show: true
    }
  },
  watch: {
    pid: {
      handler(newVal, oldVal) {
        this.pid = newVal
        if (this.pid) {
          this.truck_show()
        }
      },
      immediate: true
    }
  },
  methods: {
    initmap(options) {
      // 创建地图示例
      this._map = new ShipxyAPI.Map('map', options)
      let that = this
      // 开启轨迹服务
      ShipxyAPI.TrackService(this._map)
      // 开启,专属区服务
      ShipxyAPI.areaViewSymbol(this._map)
      // 开启,港口瓦片
      ShipxyAPI.portDataSymbol(this._map)
      //   ShipxyAPI.AreaTrackReplayService(this._map)
      //   $('#btn_player').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       // 隐藏
      //       //   that._map.latlngGraticuleServer.hide()
      //     } else {
      //       $(this).attr('is_show', '1')
      //       // 显示
      //       that._map.areaTrackReplayService.openCreateTaskLayer()
      //     }
      //   })

      // 海区
      //   $('#btn_haiqu').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       // 隐藏，全球海区：GSEA
      //       that._map.areaViewSymbol.hideArea('GSEA')
      //     } else {
      //       $(this).attr('is_show', '1')
      //       // 显示，全球海区：GSEA
      //       that._map.areaViewSymbol.showArea('GSEA')
      //     }
      //   })
      //   // 排放
      //   $('#btn_paifang').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       that._map.areaViewSymbol.hideArea('TYP')
      //     } else {
      //       $(this).attr('is_show', '1')
      //       that._map.areaViewSymbol.showArea('TYP')
      //     }
      //   })
      //   // 排放（中国）
      //   $('#btn_paifang_china').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       that._map.areaViewSymbol.hideArea('CTYP')
      //     } else {
      //       $(this).attr('is_show', '1')
      //       that._map.areaViewSymbol.showArea('CTYP')
      //     }
      //   })
      //   // 经济
      //   $('#btn_jingji').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       that._map.areaViewSymbol.hideArea('EEZ')
      //     } else {
      //       $(this).attr('is_show', '1')
      //       that._map.areaViewSymbol.showArea('EEZ')
      //     }
      //   })

      // 港口
      //   $('#btn_port').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       // 隐藏
      //       that._map.portDataSymbol.hide()
      //     } else {
      //       $(this).attr('is_show', '1')
      //       // 显示
      //       that._map.portDataSymbol.show()
      //     }
      //   })
      // 光栅
      $('#btn_guangshan').on('click', function(e) {
        e.stopPropagation()
        if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
          $(this).attr('is_show', '0')
          // 隐藏
          that._map.setRasterShow(false)
        } else {
          $(this).attr('is_show', '1')
          // 显示
          that._map.setRasterShow(true)
        }
      })
      // 时区
      //   $('#btn_areatime').on('click', function(e) {
      //     e.stopPropagation()
      //     if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
      //       $(this).attr('is_show', '0')
      //       // 隐藏
      //       that._map.areaViewSymbol.hideArea('TIME')
      //     } else {
      //       $(this).attr('is_show', '1')
      //       // 显示
      //       that._map.areaViewSymbol.showArea('TIME')
      //     }
      //   })
      // 经纬度网格
      ShipxyAPI.latlngGraticuleServer(this._map)
      $('#btn_latlnggrid').on('click', function(e) {
        e.stopPropagation()
        if ($(this).attr('is_show') != null && $(this).attr('is_show') == '1') {
          $(this).attr('is_show', '0')
          // 隐藏
          that._map.latlngGraticuleServer.hide()
        } else {
          $(this).attr('is_show', '1')
          // 显示
          that._map.latlngGraticuleServer.show()
        }
      })

      // 查询轨迹按钮
      $('#truck_add_btn').on('click', function() {
        that.truck_show()
      })
      // 清除轨迹按钮
      $('#truck_clear_btn').on('click', function() {
        that._map.trackService.removeAll()
      })
    },
    truck_show() {
      var options = {
        lineColor: 'tomato', // 线，颜色
        lineWeight: 2, // 线，粗细
        dash: true, // 是否为虚线
        dashArray: [5, 5], // 虚线间隔
        circleOverColor: 'yellow', // 轨迹点,鼠标划过时颜色
        isDilute: true, // 是否抽稀模式显示,
        isEnablePlayer: true
      }
      // 静态轨迹数据
      // var tracks = []
      // var _tmp_time = new Date().getTime() / 1000 - 3600
      // 轨迹数据(测试数据)
      // for (var i = 0; i < 20; i++) {
      //   var track = new Track()
      //   track.hdg = 100 + i // 航首向，正常值
      //   track.utc = _tmp_time + i * 20 // （必填）
      //   track.sog = 100 // （必填） 航速，正常值
      //   track.lng = 121.3 + (i * 20) / 200 // （必填）
      //   track.lat = 33.3 + (i * 20) / 200 // （必填）
      //   tracks.push(track)
      // }
      // 添加并显示轨迹

      api('waybill.history.track', { id: this.pid, type: '' }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          if (data.length === 0) {
            this.show = false
          } else {
            this.show = true
          }

          var tracks = []
          data.length &&
            data.forEach((item) => {
              var track = new Track()
              //track.hdg = 100 + i // 航首向，正常值
              if (item.track_time) {
                let date1 = item.track_time.replace(/(-)|(:)|( )/g, ',')
                let arr = date1.split(',')
                let i = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1, arr[3] * 1, arr[4] * 1, arr[5] * 1).getTime() / 1000
                track.utc = i // （必填）
              } else {
                let i = null
                track.utc = i // （必填）
              }
              track.sog = item.speed // （必填） 航速，正常值
              track.lng = Number(item.lng) // （必填）
              track.lat = Number(item.lat) // （必填）
              tracks.push(track)
            })

          //测试所用死数据
          //   var _tmp_time = new Date().getTime() / 1000 - 3600
          //   for (var i = 0; i < 20; i++) {
          //     var track = new Track()
          //     track.hdg = 100 + i // 航首向，正常值
          //      track.utc = _tmp_time + i * 20 // （必填）
          //     track.utc =new Date().getTime()
          //     track.sog = 100 // （必填） 航速，正常值
          //     track.lng = 121.3 + (i * 20) / 200 // （必填）
          //     track.lat = 33.3 + (i * 20) / 200 // （必填）
          //     tracks.push(track)
          //   }
          //console.log('wanghandi',tracks)
          this.$nextTick(() => {
            data.length && this._map.trackService.addAndShow(data[0].ship_name?data[0].ship_name:'123', tracks, options, { mmsi: data[0].nine_yard?data[0].nine_yard:'123123123' })
          })
        }
      })
    }
  },
  mounted() {
    var options = {
      ak: 'c7439ef9d3d947a39a83d24cbae0aa05',
      //地图切换控件
      basemapsControl: { isShow: true }
      //   defaultPlay: false, //是否默认播放
      //   isVisiableWithNoSignal: false, //设置船舶无信号是否可见 默认：不可见
      //   isVisiableOutOfBounds: false, //设置船舶超过视图范围是否可见 默认：不可见
      //   isVisiableShipTrack: false //设置轨迹是否可见 默认：不可见
    }
    this.initmap(options)
  }
}
</script>

<style>
.track_mouse_tip {
  z-index: 100000 !important;
}
.my-map {
  position: absolute;
  left: 0px;
  top: 127px;
  width: 80%;
  height: 510px;
  overflow: hidden;
  outline: none;
  background-color: #a3ccff;
}

.div_btn {
  position: relative;
  top: 10px;
  left: 80px;
  z-index: 888;
}

.div_btn input[type='button'] {
  cursor: pointer;
}

.count_span {
  color: red;
  background-color: #fff;
  text-align: left;
  width: 120px;
  font-weight: bolder;
  padding: 0 5px;
  border: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/map/sea-map.vue